var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLanguagePickGLobe = function SvgLanguagePickGLobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3C3C3C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M19 36c9.389 0 17-7.611 17-17S28.389 2 19 2 2 9.611 2 19s7.611 17 17 17M2 19h34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3C3C3C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M19.001 2a26 26 0 0 1 6.8 17 26 26 0 0 1-6.8 17 26 26 0 0 1-6.8-17 26 26 0 0 1 6.8-17"
  })));
};
export default SvgLanguagePickGLobe;